import React from 'react';

import { Terminal } from 'services/clients/terminal';
import { ReactComponent as APM } from '../../../../../../assets/terminal-icons/APM.svg';
import { ReactComponent as EVERPORT } from '../../../../../../assets/terminal-icons/EVERPORT.svg';
import { ReactComponent as FMS } from '../../../../../../assets/terminal-icons/FMS.svg';
import { ReactComponent as ITS } from '../../../../../../assets/terminal-icons/ITS.svg';
import { ReactComponent as LBCT } from '../../../../../../assets/terminal-icons/LBCT.svg';
import { ReactComponent as MATSON } from '../../../../../../assets/terminal-icons/MATSON.svg';
import { ReactComponent as PTSC } from '../../../../../../assets/terminal-icons/PTSC.svg';
import { ReactComponent as SSA } from '../../../../../../assets/terminal-icons/SSA.svg';
import { ReactComponent as TRAPAC } from '../../../../../../assets/terminal-icons/TRAPAC.svg';
import { ReactComponent as TTI } from '../../../../../../assets/terminal-icons/TTI.svg';
import { ReactComponent as WBCT } from '../../../../../../assets/terminal-icons/WBCT.svg';
import { ReactComponent as YTI } from '../../../../../../assets/terminal-icons/YTI.svg';

interface Props {
  opening: { terminalId: string };
  terminal?: Terminal;
}

export const TerminalIcon: React.FC<Props> = (props) => {
  const { terminalId } = props.opening;
  const { terminal } = props;
  const iconProps = { className: 'h-4 w-4' };

  switch (terminalId) {
    case 'apm':
      return <APM {...iconProps} />;
    case 'everport':
      return <EVERPORT {...iconProps} />;
    case 'fms':
      return <FMS {...iconProps} />;
    case 'its':
      return <ITS {...iconProps} />;
    case 'lbct':
      return <LBCT {...iconProps} />;
    case 'matson':
      return <MATSON {...iconProps} />;
    case 'ptsc':
      return <PTSC {...iconProps} />;
    case 'ssa_pct':
      return <SSA {...iconProps} />;
    case 'ssa_piera':
      return <SSA {...iconProps} />;
    case 'trapac':
      return <TRAPAC {...iconProps} />;
    case 'tti':
      return <TTI {...iconProps} />;
    case 'wbct':
      return <WBCT {...iconProps} />;
    case 'yti':
      return <YTI {...iconProps} />;
    default:
      return terminal ? <img src={terminal.logo} alt={terminal.name} /> : null;
  }
};
